import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

const defaultProps = {
  color: '#27A9E1',
};

const Shield = ({ color, height, width }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 420 200"
    style={{ enableBackground: 'new 0 0 420 200' }}
    xmlSpace="preserve"
    width={width}
    height={height}
  >
    <g>
      <g id="Layer_1_1_">
        <polygon
          id="XMLID_351_"
          fill="#F2F2F2"
          points="196.6,12 191.4,157.1 132.3,175.9 420,175.9 420,12"
        />
        <path
          id="XMLID_350_"
          fill={color}
          d="M0,1l4,166.7l96.3,31.3l93.7-31.3l4-166.7H0z"
        />
        <path
          id="XMLID_276_"
          fill="none"
          stroke="#FFFFFF"
          strokeMiterlimit="10"
          d="M13.5,159.4l86,27.9l83.7-27.9"
        />
        <path
          id="XMLID_1068_"
          fill="none"
          stroke="#FFFFFF"
          strokeMiterlimit="10"
          d="M11.3,14.4h174.1"
        />
      </g>
    </g>
  </svg>
);

Shield.propTypes = propTypes;

Shield.defaultProps = defaultProps;

export default Shield;
